import { RegionCode } from 'google-libphonenumber';

export enum UpdateVendorFormFieldsMap {
    BUSINESS_NAME = 'businessName',
    EMAIL = 'email',
    INTER_COUNTRY = 'interCountry',
    SWIFT = 'swift',
    IBAN = 'iban',
    INTER_PHONE = 'interPhone',
    INTER_PHONE_STATUS = 'interPhoneStatus',
    INTER_PHONE_REGION_CODE = 'interPhoneRegionCode',
    INTER_LINE_1 = 'interLine1',
    INTER_LINE_2 = 'interLine2',
    INTER_CITY = 'interCity',
    INTER_STATE = 'interState',
    INTER_POSTAL_CODE = 'interPostalCode',
    LINE_1 = 'line1',
    LINE_2 = 'line2',
    CITY = 'city',
    STATE = 'state',
    POSTAL_CODE = 'postalCode',
    ACH_ACCOUNT_NUMBER = 'achAccountNumber',
    ACH_ROUTING_NUMBER = 'achRoutingNumber',
    WIRE_ACCOUNT_NUMBER = 'wireAccountNumber',
    WIRE_ROUTING_NUMBER = 'wireRoutingNumber',
    NOTIFY_VENDOR = 'notifyVendor',
}

export interface UpdateVendorFormProps {
    [UpdateVendorFormFieldsMap.BUSINESS_NAME]: string;
    [UpdateVendorFormFieldsMap.EMAIL]: string;
    [UpdateVendorFormFieldsMap.INTER_COUNTRY]: string;
    [UpdateVendorFormFieldsMap.SWIFT]: string;
    [UpdateVendorFormFieldsMap.IBAN]: string;
    [UpdateVendorFormFieldsMap.INTER_PHONE]: string;
    [UpdateVendorFormFieldsMap.INTER_PHONE_STATUS]: boolean;
    [UpdateVendorFormFieldsMap.INTER_PHONE_REGION_CODE]: RegionCode | null;
    [UpdateVendorFormFieldsMap.INTER_LINE_1]: string;
    [UpdateVendorFormFieldsMap.INTER_LINE_2]: string;
    [UpdateVendorFormFieldsMap.INTER_CITY]: string;
    [UpdateVendorFormFieldsMap.INTER_STATE]: string;
    [UpdateVendorFormFieldsMap.INTER_POSTAL_CODE]: string;
    [UpdateVendorFormFieldsMap.LINE_1]: string;
    [UpdateVendorFormFieldsMap.LINE_2]: string;
    [UpdateVendorFormFieldsMap.CITY]: string;
    [UpdateVendorFormFieldsMap.STATE]: string;
    [UpdateVendorFormFieldsMap.POSTAL_CODE]: string;
    [UpdateVendorFormFieldsMap.ACH_ACCOUNT_NUMBER]: string;
    [UpdateVendorFormFieldsMap.ACH_ROUTING_NUMBER]: string;
    [UpdateVendorFormFieldsMap.WIRE_ACCOUNT_NUMBER]: string;
    [UpdateVendorFormFieldsMap.WIRE_ROUTING_NUMBER]: string;
    [UpdateVendorFormFieldsMap.NOTIFY_VENDOR]: boolean;
}
